// extracted by mini-css-extract-plugin
module.exports = {"root":"br_b4","body":"br_G"};